var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"root",staticClass:"cm-ig-embed"},[_c('div',{staticClass:"cm-embed is-ig",class:{ 'is-reel': _vm.isReel }},[(_vm.active && _vm.embedSrc)?_c('iframe',{attrs:{"src":_vm.embedSrc,"allow":"autoplay; encrypted-media; fullscreen; picture-in-picture;","frameborder":"0","allowfullscreen":"","scrolling":"no"}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }